// ** Modules
import { useQuery } from '@apollo/client/react';
import { gql, type TypedDocumentNode } from '@apollo/client';

// ** Types
import type { FilterOption } from '@/types/strapi';
import type { Query } from '@/types/graphql';

// ** Queries Schemas
export const getPartnerCategories: TypedDocumentNode<Pick<Query, 'allPartnerCategories'>> = gql`
    query GetPartnerCategories {
        allPartnerCategories {
            name
            value
        }
    }
`;

//////////////////
// ** Query Functions

// Get Partner Categories
export const useGetPartnerCategories = ({ allLabel }: { allLabel?: string | null }) => {
	const { data, loading, error } = useQuery(getPartnerCategories);

	const categoryData = data?.allPartnerCategories || [];

	const categories: FilterOption[] = [
		{ label: allLabel || 'All Categories', value: 'all' },
		...categoryData
			.filter((cat) => cat !== null && cat !== undefined)
			.map((cat) => ({
				label: cat?.name ?? 'Unknown',
				value: cat?.value ?? ''
			}))
	];

	return {
		categories,
		loading,
		error
	};
};
